export default "__VITE_ASSET__bLVKTnbV__"